export interface MembershipDetails {
    status: MembershipStatus,
    since:Date,
    expiry:Date,
    allowEpocket: boolean,
    allowTelephoneEnglish: boolean
}

export enum MembershipStatus {
    NONE = "NONE",
    ACTIVE = "ACTIVE",
    SUSPENDED = "SUSPENDED",
    CANCELLED = "CANCELLED",
    EXPIRED = "EXPIRED"
}